import { render } from "./ExampleText.vue?vue&type=template&id=72babf76&ts=true"
import script from "./ExampleText.vue?vue&type=script&lang=ts"
export * from "./ExampleText.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__